import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { makeStyles, TextField, MenuItem } from 'beam'
import { TenantSummary } from './login.api'

interface TenantProps {
  tenant: $TSFIXME,
  tenants: TenantSummary[],
  onChange: $TSFIXME,
}

const autoQaIdPrefix = 'TenantSelection-'

const useStyles = makeStyles(theme => ({
  listItem: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    lineHeight: '1.5em',
    minHeight: 24,
  },
}))

const TenantSelection = (props: TenantProps): ReactElement => {
  const { tenant, tenants, onChange } = props
  const classes = useStyles()
  const { t } = useTranslation()

  const handleChange = (event: $TSFIXME) => {
    onChange(event.target.value)
  }

  return (
    <TextField
      id="tenant-dropdown"
      select
      label={t('loginTo')}
      value={tenant}
      onChange={handleChange}
      InputLabelProps={{ shrink: tenant ? true : false }}
      SelectProps={{
        MenuProps: {
          getContentAnchorEl: null,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
        },
      }}
      fullWidth
      inputProps={{
        'auto-qa-id': `${autoQaIdPrefix}input-tenant`,
        'data-testid': `${autoQaIdPrefix}input-tenant`,
      }}
    >
      {tenants.map((tenant: TenantSummary) => (
        <MenuItem
          key={tenant.id}
          value={tenant.id}
          className={classes.listItem}
          auto-qa-id={`${autoQaIdPrefix}tenant-${tenant.id}`}
          data-testid={`${autoQaIdPrefix}tenant-${tenant.id}`}
        >
          {tenant.name}
        </MenuItem>
      ))}
    </TextField>
  )
}

export default TenantSelection
